<template>
  <header>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="boosted" viewBox="0 0 50 50">
        <title>Cyber Protection</title>
        <path fill="#ff7900" d="M0 0h50v50H0z"/>
        <path fill="#fff" d="M7 35h35v7H7z"/>
      </symbol>
    </svg>
    <div class="bg-dark text-white main">
      <div class="container">
        <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
          <div class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-white text-decoration-none" style="cursor: pointer">
            <svg class="bi me-2" width="70" height="50" role="img" aria-label="Boosted"><use xlink:href="#boosted"/></svg>
            <h3 class="mt-3"></h3>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Header',
};
</script>

<style src="./Header.scss" lang="scss"></style>
<style lang="scss" scoped>
.container {
  margin-top: 0;
  
  svg {
    margin-left: -0.625rem;
  }
}
@media screen and (min-width: 1024px) {
  .main {
    padding: .625rem 0;
    & * {
      padding: 0;
    }
  }
}
</style>
